import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { helpPageData } from "../../assets/data/Datas";
import { useDispatch, useSelector } from "react-redux";
import image1 from "../../assets/icons/helpIcon/questions 1.svg";
import { IoClose } from "react-icons/io5";
import { subscribe, submitFeedBack } from "../../redux/ApiSlice/HelpSlice";
import { Accordion, AccordionHeader, AccordionBody, Card, CardBody, CardFooter, Typography, Button } from "@material-tailwind/react";
import toast from "react-hot-toast";
import { IoMdArrowBack } from "react-icons/io";

export default function Questions() {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [open, setOpen] = useState(0);
    const [email, setEmail] = useState("");
    const [subscribed, setSubscribed] = useState(false);
    const [feedbackOpen, setFeedbackOpen] = useState(false);
    const [feedbackForm, setFeedbackForm] = useState({
        full_name: "",
        email: "",
        feedback: ""
    });
    const [feedbackSuccess, setFeedbackSuccess] = useState(false);
    const [feedbackLoading, setFeedbackLoading] = useState(false);
    const [feedbackError, setFeedbackError] = useState(null);
    const { loading, error } = useSelector((state) => state.help);

    const handleOpen = (value) => setOpen(open === value ? 0 : value);

    function Icon({ id, open }) {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                />
            </svg>
        );
    }

    const selectedHelp = helpPageData.find((data) => data.id === Number(id));

    const handleSubscribe = async () => {
        if (!email) return;
        const resultAction = await dispatch(subscribe(email));
        if (subscribe.fulfilled.match(resultAction)) {
            setSubscribed(true);
            setEmail("");
        }
    };

    const handleFeedbackChange = (e) => {
        setFeedbackForm({
            ...feedbackForm,
            [e.target.name]: e.target.value
        });
    };

    const handleFeedbackSubmit = async (e) => {
        e.preventDefault();
        setFeedbackLoading(true);
        setFeedbackError(null);
        setFeedbackSuccess(false);
        try {
            const resultAction = await dispatch(submitFeedBack(feedbackForm));
            if (submitFeedBack.fulfilled.match(resultAction)) {
                setFeedbackSuccess(true);
                toast.success("Thank you for your feedback!");
                setFeedbackForm({ full_name: "", email: "", feedback: "" });
                setTimeout(() => {
                    setFeedbackOpen(false);
                    setFeedbackSuccess(false);
                }, 3000);
            } else {
                setFeedbackError(resultAction.payload || "Something went wrong");
            }
        } catch (err) {
            setFeedbackError("Something went wrong");
        }
        setFeedbackLoading(false);
    };

    // Prevent background scrolling when feedback modal is open
    useEffect(() => {
        if (feedbackOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [feedbackOpen]);

    return (
        <>
            <div className="sticky top-0">
                <div className="relative flex items-center justify-center h-12 bg-[#BDE6FF] rounded-b-xl px-2 z-10">
                    <IoMdArrowBack
                        onClick={() => navigate(-1)}
                        className="absolute left-2 top-1/2 transition-transform -translate-y-1/2 text-[24px] text-black cursor-pointer"
                    />
                    <p className="text-center font-bold text-[16px] text-black flex-grow">{selectedHelp.title}</p>
                </div>
            </div>
            <div className={`px-3 mt-2 mb-5 bg-white dark:bg-[#1E1D21] ${feedbackOpen ? 'overflow-hidden h-[80vh]' : ' overflow-y-scroll'}`}>
                {selectedHelp.data?.map((data) => {
                    const sectionTitle = selectedHelp?.title?.trim()?.toLowerCase();
                    const enhanceEmails = sectionTitle === 'advertisement' || sectionTitle === 'getting started';
                    let processedAns = data.ans || '';
                    if (enhanceEmails && typeof processedAns === 'string') {
                        // Avoid double-replacing if already linked
                        const hasMickyLink = processedAns.includes('mailto:micky@chaachingg.com');
                        const hasAdvertiseLink = processedAns.includes('mailto:micky@chaachingg.com');

                        if (!hasMickyLink) {
                            processedAns = processedAns.replace(/micky@chaachingg\.com/gi, (match) =>
                                `<a href="mailto:micky@chaachingg.com" style="color:#00A3FF; font-weight:bold; cursor:pointer;">${match}</a>`
                            );
                        }
                        if (!hasAdvertiseLink) {
                            processedAns = processedAns.replace(/micky@chaachingg\.com/gi, (match) =>
                                `<a href="mailto:micky@chaachingg.com" style="color:#00A3FF; font-weight:bold; cursor:pointer;">${match}</a>`
                            );
                        }
                    }

                    const renderAsHtml = typeof processedAns === 'string' && (processedAns !== data.ans || processedAns.includes('<span') || processedAns.includes('<a '));

                    return (
                        <div className="border border-gray-300 dark:border-gray-800 rounded-[10px] mb-3" key={data.id}>
                            <Accordion
                                open={open === data.id}
                                icon={<Icon id={data.id} open={open} className="p-0" />}
                            >
                                <AccordionHeader
                                    onClick={() => handleOpen(data.id)}
                                    className="text-[12px] px-2 py-2 border-none text-gray-700 dark:text-gray-300"
                                >
                                    {data.qus}
                                </AccordionHeader>
                                <AccordionBody
                                    className="border-none px-2 text-[12px] text-gray-700 dark:text-gray-300"
                                    onClick={(e) => {
                                        const section = selectedHelp?.title?.trim()?.toLowerCase();

                                        const target = e.target;
                                        if (!target) return;

                                        // Detect the intended clickable span by style and text content
                                        const maybeSpan = target.closest && target.closest('span');
                                        if (!maybeSpan) return;

                                        const styleAttr = (maybeSpan.getAttribute && maybeSpan.getAttribute('style')) || '';
                                        const textRaw = (maybeSpan.textContent || '').trim();
                                        const text = textRaw.toLowerCase().replace(/[.,!]/g, '');

                                        const looksLikeLink = styleAttr.toLowerCase().includes('#00a3ff') &&
                                            styleAttr.toLowerCase().includes('cursor:pointer');

                                        // Case 1: Manage Your Account -> Terms and Conditions
                                        if (section === 'manage your account') {
                                            const isTermsText = text === 'terms and conditions' || (text.includes('terms') && text.includes('conditions'));
                                            if (looksLikeLink && isTermsText) {
                                                e.preventDefault?.();
                                                e.stopPropagation?.();
                                                navigate('/terms-of-use');
                                                return;
                                            }
                                        }

                                        // Case 2: Account Privacy -> here
                                        if (section === 'account privacy') {
                                            const isHere = text === 'here';
                                            if (looksLikeLink && isHere) {
                                                e.preventDefault?.();
                                                e.stopPropagation?.();
                                                navigate('/privacy-policy');
                                                return;
                                            }
                                        }
                                    }}
                                >
                                    {renderAsHtml ? (
                                        <span dangerouslySetInnerHTML={{ __html: processedAns }} />
                                    ) : (
                                        data.ans
                                    )}
                                </AccordionBody>
                            </Accordion>
                        </div>
                    )
                })}
                <div className="grid grid-cols-12 mt-4 gap-y-5">
                    <Card className="col-span-12 rounded-lg p-2 w-[100%] bg-white dark:bg-[#1E1D21] border border-gray-300 dark:border-gray-800 h-full">
                        <CardBody className="p-2 flex flex-col justify-center items-center">
                            <Typography
                                color="blue-gray"
                                className="mb-2 text-[12px] font-bold"
                            >
                                <img src={image1} className="h-12 w-12" alt="" />
                            </Typography>
                            <Typography className={`mb-1 text-[12px] dark:text-gray-400 text-center`}>
                                Do you have questions or any tips to share? Please send
                                us your comments or report any problems you experienced.
                                We read all feedback and address issues as soon as possible.
                            </Typography>
                        </CardBody>
                        <CardFooter className="flex justify-center items-center gap-4 md:p-1">
                            <Button className={`py-2 px-3 rounded-full w-[7rem] bg-[#38b6ff] text-[10px] text-[#fff]`} onClick={() => setFeedbackOpen(true)}>
                                Give Feedback
                            </Button>
                        </CardFooter>
                    </Card>
                </div>
            </div>

            {/* Feedback Modal */}
            {feedbackOpen && (
                <div className="absolute h-full p-2 inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white dark:bg-gray-900 rounded-lg p-6 w-[90vw] max-w-md relative">
                        <button
                            className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
                            onClick={() => {
                                setFeedbackOpen(false);
                                setFeedbackSuccess(false);
                                setFeedbackError(null);
                            }}
                        >
                            <IoClose className="text-[20px]" />
                        </button>
                        <h3 className="text-lg font-bold mb-2 text-center">Give Feedback</h3>
                        <form onSubmit={handleFeedbackSubmit} className="flex flex-col gap-2">
                            <input
                                type="text"
                                name="full_name"
                                placeholder="Full Name"
                                value={feedbackForm.full_name}
                                onChange={handleFeedbackChange}
                                className="text-[13px] placeholder:text-[12px] border rounded px-2 py-1.5 text-sm outline-none"
                                required
                            />
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={feedbackForm.email}
                                onChange={handleFeedbackChange}
                                className="text-[13px] placeholder:text-[12px] border rounded px-2 py-1.5 text-sm outline-none"
                                required
                            />
                            <textarea
                                name="feedback"
                                placeholder="Your feedback"
                                value={feedbackForm.feedback}
                                onChange={handleFeedbackChange}
                                className="text-[13px] placeholder:text-[12px] border rounded px-2 py-1 text-sm resize-none outline-none"
                                rows={3}
                                required
                            />
                            <button
                                type="submit"
                                className="bg-[#38b6ff] text-white rounded py-1 text-sm mt-2 disabled:opacity-60"
                                disabled={feedbackLoading}
                            >
                                {feedbackLoading ? "Submitting..." : "Submit"}
                            </button>
                            {feedbackSuccess && <p className="text-green-600 text-xs text-center">Thank you for your feedback!</p>}
                            {feedbackError && <p className="text-red-500 text-xs text-center">{feedbackError}</p>}
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}
